export default __webpack_public_path__ + "static/media/logo.089da519.png";